import { useState, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isMobile } from 'react-device-detect';
import iconCollapse from '../../../icons/caret-collapse.svg';
import iconExpand from '../../../icons/caret-expand.svg';
import iconSearch from '../../../icons/search.svg';
import ReloadGridButton from './ReloadGridButton';

const SubHeader = ({ filtersCollection, onClick, filtering, visibleFilters, reloadGrid, renderParenCallBack }) => {
  const [showFilters, setShowFilters] = useState(!isMobile);

  if (visibleFilters.length === 0) {
    return <span />;
  }

  return (
    <div className='filters'>
      <div className='filters-navigator'>
        {null !== reloadGrid && <ReloadGridButton grid={reloadGrid} renderParenCallBack={renderParenCallBack} />}
        <span className='simple-link-button' onClick={() => setShowFilters(!showFilters)}>
          {showFilters ? (
            <>
              <img src={iconCollapse} alt='' />
              <FormattedMessage id='Collapse filters' />
            </>
          ) : (
            <>
              <img src={iconExpand} alt='' />
              <FormattedMessage id='Expand filters' />
            </>
          )}
        </span>
      </div>
      {showFilters && (
        <div className='filters-wrapper'>
          {filtersCollection.map((item, key) => cloneElement(item, { key }))}
          <button type='button' onClick={onClick} className={`button reverse filter-button ${filtering && 'loading'}`}>
            <FormattedMessage id='Filter' />
            <img src={iconSearch} alt='search' />
          </button>
        </div>
      )}
    </div>
  );
};

SubHeader.propTypes = {
  filters: PropTypes.array,
};

SubHeader.defaultProps = {
  filters: [],
};

export default SubHeader;
